import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Autocomplete } from '@mui/material';
import Swal from 'sweetalert2';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { BASE_URL } from '../../App';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {Backdrop } from '@mui/material';
const SparesAndLabourReport = () => {
    const [branch, setBranch] = useState(null);
    const [type, setType] = useState(null);
    const [ascCode, setAscCode] = useState(null);  
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [currentReport, setCurrentReport] = useState('');  
    const [loadingType, setLoadingType] = useState(null); 
    const [branches, setBranches] = useState([]);
    const [ascCodes, setAscCodes] = useState([]);  
    const login_id = localStorage.getItem("LOGIN_ID");
    const usertype = localStorage.getItem("usertype");
    const user_branch = localStorage.getItem("BRANCH_CODE");
    const typeOptions = [
        { label: 'ALL', value: 'ALL' },
        { label: 'CASC', value: 'CASC' },
        { label: 'DASC', value: 'DASC' }
    ];

    useEffect(() => {
        fetchBranches();
    }, []);

    const fetchBranches = async () => {
        try {
            const branchRes = await axios.post(`${BASE_URL}/Branchforsparesandlabourreport`,{login_id:login_id,user_branch:user_branch});
            
            const branchOptions = branchRes.data.branches.map(b => ({
                label: `${b.BRANCHCODE}-${b.BRANCHNAME}`,
                value: b.BRANCHCODE
            }));
            setBranches(branchOptions);
        } catch (error) {
            console.error('Error fetching branch data:', error);
           // Swal.fire('Error', 'Failed to load branch data', 'error');
        }
    };

    const fetchAscCodes = async (selectedBranch, selectedType) => {
        if (!selectedBranch || !selectedType) return;
    
        try {
            const ascRes = await axios.post(`${BASE_URL}/getdealerforspandlab`, {
                userbranch: user_branch,
                loginid: login_id,
                selectedtype: selectedType.value,
                selectedbranch: selectedBranch.value,
            });

            const ascOptions = ascRes.data.data.map(a => ({
                label: a.DEALER_DISPLAY,  
                value: a.DEALER_CODE     
            }));

            setAscCodes(ascOptions);
        } catch (error) {
            console.error('Error fetching ASC codes:', error);
            //Swal.fire('Error', 'Failed to load ASC codes', 'error');
        }
    };

    const handleBranchChange = (event, newValue) => {
        setBranch(newValue);
        if (newValue && type) {
            fetchAscCodes(newValue, type);
        }
    };

    const handleTypeChange = (event, newValue) => {
        setType(newValue);
        if (branch && newValue) {
            fetchAscCodes(branch, newValue);
        }
    };

    
const handleSearch = async (reportType) => {
    if (!branch || !fromDate || !toDate) {
        Swal.fire("Warning", "Please fill all the required fields", "warning");
        return;
    }

    setLoading(true);
    
    try {
        const apiUrl = reportType === "SPARE" 
            ? `${BASE_URL}/getSpareReport` 
            : `${BASE_URL}/getLabourReport`;

        const res = await axios.post(apiUrl, {
            branch: branch?.value,
            type: type?.value,
            ascCode: ascCode?.value,
            fromDate,
            toDate,
        });

        if (!res.data.data || res.data.data.length === 0) {
            Swal.fire("No Data Found", `No records available for ${reportType}`, "info");
            return;
        }

        // Create Excel file
        const worksheet = XLSX.utils.json_to_sheet(res.data.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, `${reportType}_Report`);
        XLSX.writeFile(workbook, `${reportType}_Report.xlsx`);

        //Swal.fire("Success", "Excel file has been downloaded!", "success");
    } catch (error) {
        Swal.fire("Info", `Failed to fetch ${reportType} data`, "error");
    } finally {
        setLoading(false);
    }
};
    // useEffect(() => {
    //     console.log("Updated Data:", data);
    // }, [data]);
    const handleDownloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, `${currentReport}_Report`);
        XLSX.writeFile(workbook, `${currentReport}_Report.xlsx`);
    };

    return (
        <Box sx={{ padding: 3 }}>
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h5" sx={{ color: '#117864', fontWeight: 'bold', mb: 2 }}>
                        {/* SPARES AND LABOURS REPORT */}
                    </Typography>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <Autocomplete
                            options={branches}
                            value={branch}
                            onChange={handleBranchChange}
                            getOptionLabel={(option) => option.label || ''}
                            renderInput={(params) => <TextField {...params} label="Branch" />}
                            sx={{ minWidth: 240 }}
                        />

                        <Autocomplete
                            options={typeOptions}
                            value={type}
                            onChange={handleTypeChange}
                            getOptionLabel={(option) => option.label || ''}
                            renderInput={(params) => <TextField {...params} label="Type" />}
                            sx={{ minWidth: 240 }}
                        />

                        <Autocomplete
                            options={ascCodes}
                            value={ascCode}
                            onChange={(event, newValue) => setAscCode(newValue)}
                            getOptionLabel={(option) => option?.label || ''}
                            renderInput={(params) => (
                                <TextField {...params} label="ASC Code" variant="outlined" />
                            )}
                            loading={ascCodes.length === 0}
                            noOptionsText="No ASC Codes found"
                            sx={{ minWidth: 240 }}
                        />
                         <TextField
                            label="From Date"
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ minWidth: 240 }}
                        />

                        <TextField
                            label="To Date"
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ minWidth: 240 }}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
                       
                    </Box>

                    <Box display="flex" justifyContent="flex-start" gap={2} mt={3}>
                    <Button 
            variant="contained" 
            color="primary" 
            onClick={() => handleSearch('SPARE')} 
            disabled={loadingType === 'SPARE'}
            startIcon={<FileDownloadIcon />}
        >
            {loadingType === 'SPARE' ? <CircularProgress size={24} /> : "SPARE REPORT"}
        </Button>

        <Button 
            variant="contained" 
            color="secondary" 
            onClick={() => handleSearch('LABOUR')} 
            disabled={loadingType === 'LABOUR'}
            startIcon={<FileDownloadIcon />}
        >
            {loadingType === 'LABOUR' ? <CircularProgress size={24} /> : "LABOUR REPORT"}
        </Button>

                        {/* <Button variant="contained" color="success" onClick={handleDownloadExcel}>
                            DOWNLOAD EXCEL
                        </Button> */}
                    </Box>
                </CardContent>
            </Card>

            {showTable && (
               <TableContainer component={Paper} sx={{ maxHeight: 490, overflow: 'auto' }}>
               <Table stickyHeader>
                   <TableHead>
                       <TableRow>
                           {currentReport === 'SPARE' ? (
                               <>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Doc No</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Token No</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Serial No</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>ASC Code</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>ASC Name</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>ASC Type</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Product Item Code</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Product Description</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Spare Item Code</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Spare Description</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Unit Cost</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Qty</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Tax Amount</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Total Amount</TableCell>
                               </>
                           ) : (
                               <>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Doc No</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Token No</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Serial No</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>ASC Code</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>ASC Name</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>ASC Type</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Product Item Code</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Product Description</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Labour Charge</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Unit Cost</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Tax Percentage</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Tax Amount</TableCell>
                                   <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#1976D2', color: '#fff' }}>Total Amount</TableCell>
                               </>
                           )}
                       </TableRow>
                   </TableHead>
           
                   <TableBody>
                    
                       {data.length > 0 ? (
                           data.map((item, index) => (
                               <TableRow key={index}>
                                   {currentReport === 'SPARE' ? (
                                       <>
                                           <TableCell>{item.DOC_NO}</TableCell>
                                           <TableCell>{item.TOKEN_No}</TableCell>
                                           <TableCell>{item.SERIAL_No}</TableCell>
                                           <TableCell>{item.ASC_CODE}</TableCell>
                                           <TableCell>{item.ASC_NAME}</TableCell>
                                           <TableCell>{item.ASC_TYPE}</TableCell>
                                           <TableCell>{item.PRODUCT_ITEM_CODE}</TableCell>
                                           <TableCell>{item.PRODUCT_DESCRIPTION}</TableCell>
                                           <TableCell>{item.SPARE_ITEM_CODE}</TableCell>
                                           <TableCell>{item.SPARE_DESCRIPTION}</TableCell>
                                           <TableCell>{item.UNIT_COST}</TableCell>
                                           <TableCell>{item.QTY}</TableCell>
                                           <TableCell>{item.TAX_AMOUNT}</TableCell>
                                           <TableCell>{item.TOTAL_AMOUNT}</TableCell>
                                       </>
                                   ) : (
                                       <>
                                           <TableCell>{item.DOC_NO}</TableCell>
                                           <TableCell>{item.TOKEN_No}</TableCell>
                                           <TableCell>{item.SERIAL_No}</TableCell>
                                           <TableCell>{item.ASC_CODE}</TableCell>
                                           <TableCell>{item.ASC_NAME}</TableCell>
                                           <TableCell>{item.ASC_TYPE}</TableCell>
                                           <TableCell>{item.PRODUCT_ITEM_CODE}</TableCell>
                                           <TableCell>{item.PRODUCT_DESCRIPTION}</TableCell>
                                           <TableCell>{item.LABOUR_CHARGE}</TableCell>
                                           <TableCell>{item.UNIT_COST}</TableCell>
                                           <TableCell>{item.TAX_PERCENT}</TableCell>
                                           <TableCell>{item.TAX_AMOUNT}</TableCell>
                                           <TableCell>{item.TOTAL_AMOUNT}</TableCell>
                                       </>
                                   )}
                               </TableRow>
                           ))
                       ) : (
                           <TableRow>
                               <TableCell colSpan={14} align="center">No Record Found</TableCell>
                           </TableRow>
                       )}
                   </TableBody>
               </Table>
           </TableContainer>
           
            )}
             <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Box>
        
    );
};

export default SparesAndLabourReport;
